<template>


  <div class="bg-color-darkest rn-splite-style" >
    <div class="split-wrapper">
      <div class="row no-gutters radius-10 align-items-center">
        <div class="col-lg-12 col-xl-6 col-12 order-2" >
          <div class="thumbnail" style="padding: 50px;">

            <router-link  to="/about-agency"><img :src="require(`@/assets/images/about/about-company-01.png`)" alt="Split Image"/></router-link>

          </div>
        </div>
        <div class="col-lg-12 col-xl-6 col-12 order-1" >
          <div class="split-inner ">
            <h4 class="title">{{ splitData.title }}</h4>
            <div class="content ql-editor">
              <p class="description" v-html="splitData.description"></p>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '../../components/elements/button/Button'
import Counter from '../../components/elements/counterUp/Counter'

export default {
  name: 'Split',
  components: {Counter, Button},
  props: {
    splitStyle: {
      type: Number,
      default: 1
    },
    splitData: {}
  }
}
</script>